import xss, { escapeAttrValue } from "xss"

const urlRegex = /(https?:\/\/[^\s]+)/g

function textHasUrl(text: string) {
    return urlRegex.test(text)
}

function urlify(text: string, style?: string, textForUrl?: string) {
    return text.replace(
        urlRegex,
        (url) =>
            `<a class=${style} target='_blank' rel='noopener noreferrer' href=${url}>${
                textForUrl || url
            }</a>`
    )
}

function ignoreStylesClass(text: string) {
    return xss(text, {
        onIgnoreTagAttr: (tag: string, name: string, value: string) => {
            if (name.substring(0, 5) === "class") {
                return name + '="' + escapeAttrValue(value) + '"'
            }
        },
    })
}

export { urlify, ignoreStylesClass, textHasUrl }
